"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_RX_PRE_ORDER = exports.GET_PHARMACY_HOME_SCREEN_BANNER = exports.GET_ORDER_APPOINTMENT_CARD = exports.GET_HOME_SCREEN_BANNER = exports.GET_BANNERS_WEB = exports.GET_BANNERS_TOP = exports.GET_BANNERS_QUICK_BOOKING = exports.GET_BANNERS_MIDDLE = exports.GET_BANNERS_BOTTOM = exports.GET_BANNERS = void 0;
const GET_BANNERS = exports.GET_BANNERS = 'getBanners';
const GET_RX_PRE_ORDER = exports.GET_RX_PRE_ORDER = 'getRxPreOrder';
const GET_BANNERS_TOP = exports.GET_BANNERS_TOP = 'getBannersTop';
const GET_BANNERS_MIDDLE = exports.GET_BANNERS_MIDDLE = 'getBannersMiddle';
const GET_BANNERS_BOTTOM = exports.GET_BANNERS_BOTTOM = 'getBannersBottom';
const GET_BANNERS_QUICK_BOOKING = exports.GET_BANNERS_QUICK_BOOKING = 'getBannersQuickBooking';
const GET_ORDER_APPOINTMENT_CARD = exports.GET_ORDER_APPOINTMENT_CARD = 'getOrderAppointmentList';
const GET_BANNERS_WEB = exports.GET_BANNERS_WEB = 'getBannersWeb';
const GET_HOME_SCREEN_BANNER = exports.GET_HOME_SCREEN_BANNER = 'getHomeScreenBanner';
const GET_PHARMACY_HOME_SCREEN_BANNER = exports.GET_PHARMACY_HOME_SCREEN_BANNER = 'getPharmacyHomeScreenBanner';